import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import styles from 'pages/products/productProperties/edit/styles';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { updateProductProperty } from 'store/actions/productProperties/updateProductProperties';

class ProductPropertiesEdit extends React.Component {
    componentDidMount() {
        this.props.initialize(this.props.currentValues);
    }

    submit = (formValues) => {
        if (utils.isEmpty(formValues)) {
            return null;
        }

        const formattedValues = {
            priority: formValues.priority,
        };

        return new Promise((resolve) => {
            return this.props.updateProductProperty({
                form: formattedValues,
                productId: this.props.productId,
                propertyId: this.props.propertyId,
                callback: resolve,
            });
        });
    }

    render() {
        const { handleSubmit, submitting, translate } = this.props;

        return (
            <form onSubmit={ handleSubmit(this.submit) }>
                <div>
                    <Field
                        component={ RenderTextInputField }
                        label={ translate('resources.products.fields.priority') }
                        name='priority'
                        style={ styles.formElement }
                        validate={ validations.required }
                    />
                </div>

                <div style={ styles.buttons }>
                    <SubmitButton
                        disabled={ submitting }
                        loading={ submitting }
                    />
                </div>
            </form>
        );
    }
}

ProductPropertiesEdit.propTypes = {
    currentValues: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    productId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    propertyId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    updateProductProperty: PropTypes.func.isRequired,
};

let HOCProductPropertiesEdit = reduxForm({
    form: 'product_properties_edit',
})(ProductPropertiesEdit);

HOCProductPropertiesEdit = connect(
    null,
    {
        updateProductProperty: updateProductProperty,
    }
)(HOCProductPropertiesEdit);

export default translate(HOCProductPropertiesEdit);



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/edit/ProductPropertiesEdit.js